import Vue from 'vue';
import CopilotAPI from 'dashboard/api/copilot';

// Fonte única do "sentimento ao vivo" por conversa (nativo, custo zero).
// Alimenta tanto o chip no compositor quanto o painel do Copiloto, com uma
// única chamada — a action é deduplicada por conversa + última mensagem.
export const state = {
  // { [conversationId]: { sentiment, score } }
  liveSentiment: {},
  // { [conversationId]: { lastMessageId, fetching } }
  meta: {},
};

export const getters = {
  getLiveSentiment: $state => conversationId =>
    $state.liveSentiment[conversationId] || null,
};

export const actions = {
  async fetchLiveSentiment({ commit, state: $state }, { conversationId, lastMessageId }) {
    if (!conversationId) return;
    const meta = $state.meta[conversationId] || {};
    // Já buscando, ou já temos o valor para esta mesma última mensagem.
    if (meta.fetching) return;
    if (
      lastMessageId &&
      meta.lastMessageId === lastMessageId &&
      $state.liveSentiment[conversationId]
    ) {
      return;
    }

    commit('SET_META', { conversationId, meta: { ...meta, fetching: true } });
    try {
      const { data } = await CopilotAPI.processEvent({
        type: 'sentiment_live',
        conversationId,
        force: true,
      });
      if (data.message && typeof data.message === 'object') {
        commit('SET_LIVE_SENTIMENT', { conversationId, value: data.message });
      }
      commit('SET_META', { conversationId, meta: { lastMessageId, fetching: false } });
    } catch (error) {
      commit('SET_META', { conversationId, meta: { ...meta, fetching: false } });
    }
  },
};

export const mutations = {
  SET_LIVE_SENTIMENT($state, { conversationId, value }) {
    Vue.set($state.liveSentiment, conversationId, value);
  },
  SET_META($state, { conversationId, meta }) {
    Vue.set($state.meta, conversationId, meta);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
